import React from 'react';
import { useRecoilValue } from 'recoil';
import { ShopifyCart } from '../../models/ShopifyCart.model';
import { ShopifyLineItem } from '../../models/ShopifyLineItem.model';
import styles from './OrderSummaryDiscounts.module.scss';
import { toViewPriceFnState } from '../../recoil/atoms';

interface OrderSummaryDiscountsProps {
  cart?: ShopifyCart;
}

const discountApplications = (c: ShopifyCart | undefined) =>
  c?.lineItems?.reduce((acc: any[], item: ShopifyLineItem) => {
    const lineItemDiscounts = item.discounts;
    return lineItemDiscounts.length > 0 ? [...acc, ...lineItemDiscounts] : acc;
  }, []) ?? [];

export const OrderSummaryDiscounts: React.FC<OrderSummaryDiscountsProps> = ({ cart }: OrderSummaryDiscountsProps) => {
  const toViewPriceFn = useRecoilValue(toViewPriceFnState);
  const discounts: { [title: string]: number } = discountApplications(cart).reduce((prev, curr) => {
    return {
      ...prev,
      [curr.title]: (prev[curr.title] ?? 0) + curr.amount,
    };
  }, {});

  return (
    <React.Fragment>
      {!!cart &&
        Object.keys(discounts).map((title, index) => (
          <div className={styles.hlCartLine} key={index}>
            <span>{title}</span>
            <span className={styles.dollarTotal}>-{toViewPriceFn(discounts[title])}</span>
          </div>
        ))}
    </React.Fragment>
  );
};

export default OrderSummaryDiscounts;
